import { Input } from "../../components/ui/input";
import Header from "../../components/VibrantSolComponents/Header";
import { Search } from "lucide-react";
import bannerimg from "../../banner-35.jpg";
import Footer from "../../components/VibrantSolComponents/Footer";
import { useState } from "react";

function Faq() {
  const [searchTerm, setSearchTerm] = useState("");

  // Optionally you can implement search/filter logic here on FAQs

  return (
    <>
      <div className="min-h-screen">
        <Header />
        <nav className="flex justify-center py-4 bg-gray-50">
          <ol className="flex items-center space-x-2 text-sm text-gray-600">
            <li>
              <span className="text-gray-400 font-medium cursor-default select-none">
                Home
              </span>
            </li>
            <li>
              <span className="text-gray-300 font-medium select-none">——</span>
            </li>
            <li>
              <span className="text-gray-700 font-medium">FAQ&apos;s</span>
            </li>
          </ol>
        </nav>

        <section className="pt-12 pb-2 px-4 max-w-7xl mx-auto w-full">
          <div className="flex flex-col items-center text-center max-w-2xl mx-auto mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold mb-6 secdory-font">
              Frequently Asked Questions
            </h2>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                // Implement search handling if needed
              }}
              className="w-full max-w-xl relative"
              role="search"
              aria-label="Search FAQs"
            >
              <Input
                placeholder="What are you looking for?"
                className="w-full pr-12 pl-10 py-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                aria-describedby="search-icon"
              />
              <button
                type="submit"
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                aria-label="Search FAQs"
                id="search-icon"
              >
                <Search size={18} />
              </button>
            </form>
          </div>
        </section>

        <section className="px-4 max-w-7xl mx-auto w-full">
          <div className="rounded-lg overflow-hidden shadow mb-16">
            <img
              src={bannerimg}
              alt="Health Banner"
              className="w-full object-cover"
              loading="lazy"
            />
          </div>

          {/* FAQs Sections */}

          {[
            {
              title: "Hair Regrowth",
              faqs: [
                {
                  question:
                    "How soon will I see results from hair regrowth treatments?",
                  answer:
                    "Complexion-perfecting natural foundation enriched with antioxidant-packed superfruits, vitamins, and other skin-nourishing nutrients. Creamy liquid formula sets with a pristine matte finish for soft, velvety smooth skin.  Say hello to flawless, long-lasting foundation that comes in 7 melt-into-your-skin shades. This lightweight, innovative formula creates a smooth, natural matte finish that won’t settle into lines. It’s the perfect fit for your skin. 1 fl. oz.",
                },
                {
                  question: "Are the treatments safe for all hair types?",
                  answer:
                    "Complexion-perfecting natural foundation enriched with antioxidant-packed superfruits, vitamins, and other skin-nourishing nutrients. Creamy liquid formula sets with a pristine matte finish for soft, velvety smooth skin.",
                },
                {
                  question:
                    "How soon will I see results from hair regrowth treatments?",
                  answer:
                    "Complexion-perfecting natural foundation enriched with antioxidant-packed superfruits, vitamins, and other skin-nourishing nutrients. Creamy liquid formula sets with a pristine matte finish for soft, velvety smooth skin.  Say hello to flawless, long-lasting foundation that comes in 7 melt-into-your-skin shades. This lightweight, innovative formula creates a smooth, natural matte finish that won’t settle into lines. It’s the perfect fit for your skin. 1 fl. oz.",
                },
                {
                  question: "Are the treatments safe for all hair types?",
                  answer:
                    "Complexion-perfecting natural foundation enriched with antioxidant-packed superfruits, vitamins, and other skin-nourishing nutrients. Creamy liquid formula sets with a pristine matte finish for soft, velvety smooth skin.  Say hello to flawless, long-lasting foundation that comes in 7 melt-into-your-skin shades. This lightweight, innovative formula creates a smooth, natural matte finish that won’t settle into lines. It’s the perfect fit for your skin. 1 fl. oz.",
                },
              ],
            },
            {
              title: "Skin Care",
              faqs: [
                {
                  question: "Do your skin treatments work for sensitive skin?",
                  answer:
                    "Absolutely. We use dermatologist-approved, hypoallergenic products to ensure safety and results.",
                },
                {
                  question: "How many sessions will I need?",
                  answer:
                    "It depends on the treatment type, but most clients achieve desired results within 4–8 sessions.",
                },
                {
                  question: "Do your skin treatments work for sensitive skin?",
                  answer:
                    "Absolutely. We use dermatologist-approved, hypoallergenic products to ensure safety and results.",
                },
                {
                  question: "How many sessions will I need?",
                  answer:
                    "It depends on the treatment type, but most clients achieve desired results within 4–8 sessions.",
                },
              ],
            },
            {
              title: "Sexual Health",
              faqs: [
                {
                  question: "Is my information kept private?",
                  answer:
                    "Yes, all consultations and treatments are handled with complete confidentiality.",
                },
                {
                  question: "Do you offer online consultations?",
                  answer:
                    "Yes, we offer secure virtual appointments for your convenience and privacy.",
                },
                {
                  question: "Is my information kept private?",
                  answer:
                    "Yes, all consultations and treatments are handled with complete confidentiality.",
                },
                {
                  question: "Do you offer online consultations?",
                  answer:
                    "Yes, we offer secure virtual appointments for your convenience and privacy.",
                },
                {
                  question: "Is my information kept private?",
                  answer:
                    "Yes, all consultations and treatments are handled with complete confidentiality.",
                },
                {
                  question: "Do you offer online consultations?",
                  answer:
                    "Yes, we offer secure virtual appointments for your convenience and privacy.",
                },
              ],
            },
            {
              title: "Weight Loss",
              faqs: [
                {
                  question: "Are your programs customized?",
                  answer:
                    "Yes, we create personalized plans based on your goals, health, and lifestyle.",
                },
                {
                  question: "Do you offer diet and exercise guidance?",
                  answer:
                    "Absolutely, we provide a complete plan including nutrition and physical activity guidance.",
                },
                {
                  question: "Are your programs customized?",
                  answer:
                    "Yes, we create personalized plans based on your goals, health, and lifestyle.",
                },
                {
                  question: "Do you offer diet and exercise guidance?",
                  answer:
                    "Absolutely, we provide a complete plan including nutrition and physical activity guidance.",
                },
              ],
            },
            {
              title: "Mental Health",
              faqs: [
                {
                  question: "Do you provide therapy sessions?",
                  answer:
                    "Yes, we offer individual, couples, and group therapy sessions with licensed professionals.",
                },
                {
                  question: "Can I book an appointment online?",
                  answer:
                    "Yes, you can easily schedule appointments through our online booking system.",
                },
                {
                  question: "Do you provide therapy sessions?",
                  answer:
                    "Yes, we offer individual, couples, and group therapy sessions with licensed professionals.",
                },
                {
                  question: "Can I book an appointment online?",
                  answer:
                    "Yes, you can easily schedule appointments through our online booking system.",
                },
              ],
            },
          ].map(({ title, faqs }) => (
            <article
              key={title}
              className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-16"
              aria-labelledby={`${title.replace(/\s+/g, "-")}-heading`}
            >
              <h2
                id={`${title.replace(/\s+/g, "-")}-heading`}
                className="text-2xl font-semibold md:col-span-1 secdory-font"
              >
                {title}
              </h2>
              <div className="md:col-span-3 space-y-4">
                {faqs.map(({ question, answer }, index) => (
                  <details
                    key={index}
                    className="border-b pb-3 group transition"
                  >
                    <summary
                      tabIndex={0}
                      className="cursor-pointer text-lg font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 flex justify-between items-center"
                    >
                      {question}
                      <svg
                        className="w-5 h-5 ml-2 shrink-0 rotate-0 group-open:rotate-180 transform transition-transform duration-300"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 9l-7 7-7-7"
                        />
                      </svg>
                    </summary>
                    <p className="mt-2 text-gray-600">{answer}</p>
                  </details>
                ))}
              </div>
            </article>
          ))}
        </section>
        <Footer />
      </div>
    </>
  );
}

export default Faq;
